import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ExpirationsStyle from './css/ExpirationsStyle'
import { dateYMD } from '../../../../utilities/utilities'

function Expirations(props) {
  const { stockOutItemDetail, cb } = props
  const [expirationDate, setExpirationDate] = useState('')

  const onClickClose = (e) => {
    cb('Close')
  }

  const onClickApply = (e) => {
    stockOutItemDetail.expiration_date = expirationDate
    // const exp_date = stockOutItemDetail.expirations.find(exp => (new Date(exp.date).getTime()) === (new Date(expirationDate).getTime()))
    // exp_date.quantity -= stockOutItemDetail.quantity
    cb('Apply')
  }

  const onClickExpirationDate = (e) => {
    // Uncheck expiration dates which are note selected
    const uncheckNotSelectedExpDate = () => {
      const exp_dates_container = document.getElementById('expiration-dates-container')
      const checks_marks = exp_dates_container.querySelectorAll('.check-mark')
      checks_marks.forEach(cm => {
        if (cm.classList.contains('show-check-mark'))
          cm.classList.remove('show-check-mark')
      })
    }

    // Check selected date
    const checkSelectedExpDate = () => {
      const exp_date = e.target.closest('.expiration-date')
      const check_mark = exp_date.querySelector('.check-mark')
      if (!check_mark.classList.contains('show-check-mark')) {
        check_mark.classList.add('show-check-mark')
        setExpirationDate(exp_date.id)
      }
    }

    uncheckNotSelectedExpDate()
    checkSelectedExpDate()
  }

  return (
    <React.Fragment>
      <div id='expirations-container'>
        <div id='item-name'>
          {`Pull-out ${stockOutItemDetail.quantity} ${stockOutItemDetail.unit} of `}
          <span><i>{stockOutItemDetail.name}</i></span>
        </div>
        <div id='expiration-dates-container'>
        {
          stockOutItemDetail.expirations
          .map((exp, i) => (
            <button
              key={i}
              id={dateYMD(new Date(exp.date))}
              onClick={onClickExpirationDate}
              disabled={(exp.quantity < stockOutItemDetail.quantity)}
              className={stockOutItemDetail.expirations.length === (i + 1)
                ? (exp.quantity < stockOutItemDetail.quantity)
                  ? 'expiration-date last-exp-date'
                  : 'expiration-date active last-exp-date'
                : (i === 0)
                  ? (exp.quantity < stockOutItemDetail.quantity)
                   ? 'expiration-date'
                   : 'top-anchor expiration-date active'
                  : (exp.quantity < stockOutItemDetail.quantity)
                   ? 'expiration-date'
                   : 'expiration-date active'
              }>
              <div className='exp-date-data'>
                <div>Expiration Date:&nbsp;{dateYMD(new Date(exp.date))}</div>
                <div>Inventory: {exp.quantity}</div>
              </div>
              <div className='check-mark-container'>
                <div className='check-mark'>
                  <FontAwesomeIcon icon='check'/>
                </div>
              </div>
            </button>
          ))
        }
        </div>
        <div id='expiration-button-container'>
          <button
            onClick={onClickClose}
            className='top-anchor pospro-action-btn'>
            Close
          </button>
          <button
            id='exp-date-btn-apply'
            disabled={(expirationDate === '')}
            onClick={onClickApply}
            className='bottom-anchor pospro-action-btn'>
            Apply
          </button>
        </div>
      </div>
      <ExpirationsStyle />
    </React.Fragment>
  )
}

export default React.memo(Expirations)
